import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import ConsultationModal from '../components/ConsultationModal';

const Contact = () => {
  const [isConsultationModalOpen, setIsConsultationModalOpen] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isHovered, setIsHovered] = useState(false);

  const openConsultationModal = () => {
    setIsConsultationModalOpen(true);
  };

  const closeConsultationModal = () => {
    setIsConsultationModalOpen(false);
  };
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    position: '',
    county: '',
    program: '',
    experience: '',
    objectives: '',
    message: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    // Simulate form submission
    setTimeout(() => {
      setIsSubmitting(false);
      Swal.fire({
        icon: 'success',
        title: 'Inquiry Sent!',
        text: 'Thank you for your inquiry! We will contact you within 24 hours.',
        confirmButtonColor: '#2563eb'
      });
      setFormData({
        name: '',
        email: '',
        phone: '',
        position: '',
        county: '',
        campaignType: '',
        budget: '',
        timeline: '',
        message: ''
      });
    }, 2000);
  };

  const officeLocations = [
    {
      city: "Kehosa Institute for Strategic Studies (KISS)",
      address: "c/o Democracy Institute (DI), Nairobi",
      phone: "+254 722 655911",
      email: "kehosainstitute@gmail.com",
      hours: "Mon-Fri: 8AM-6PM (EAT)"
    },
    {
      city: "Democracy Institute (DI)",
      address: "Strategic Partnerships Center, Nairobi",
      phone: "+254 722 655911",
      email: "kehosainstitute@gmail.com",
      hours: "Mon-Fri: 8AM-6PM (EAT)"
    },
    {
      city: "iTarget Media EA",
      address: "Digital Innovation Hub, Nairobi",
      phone: "+254 722 655911",
      email: "kehosainstitute@gmail.com",
      hours: "Mon-Fri: 8AM-6PM (EAT)"
    }
  ];

  const consultationTypes = [
    {
      type: "Strategy101 Registration",
      duration: "Comprehensive Program",
      price: "KES 150,000",
      description: "Complete 10 Keys to Victory training program with masterclass access"
    },
    {
      type: "Individual Masterclass",
      duration: "2-3 hours per module",
      price: "KES 15,000 per module",
      description: "Access to individual DI-KISS masterclass tutorials and materials"
    },
    {
      type: "Strategic Consultation",
      duration: "1 hour assessment",
      price: "KES 25,000",
      description: "Personalized strategic assessment and customized development plan"
    }
  ];

  const carouselItems = [
    {
      image: "https://images.unsplash.com/photo-1552664730-d307ca884978?w=1200&h=600&fit=crop",
      title: "Register for Strategy101",
      subtitle: "Join the 10 Keys to Victory™ Program",
      description: "Strategy Is the Foundation of Success. We Are Ready and Open for Business — Are You? Join strategic leaders who have mastered electoral success.",
      cta: "Register Now"
    },
    {
      image: "https://images.unsplash.com/photo-1559136555-9303baea8ebd?w=1200&h=600&fit=crop",
      title: "Personalized Consultation",
      subtitle: "Strategic Assessment & Development Plans",
      description: "Get personalized strategic assessment and customized development plans from our expert political strategists and campaign professionals.",
      cta: "Book Consultation"
    },
    {
      image: "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?w=1200&h=600&fit=crop",
      title: "DI-KISS Masterclasses",
      subtitle: "Expert-Led Training Modules",
      description: "Access comprehensive training modules covering all aspects of successful campaigning. Learn from the best in political strategy.",
      cta: "View Masterclasses"
    }
  ];

  useEffect(() => {
    if (!isHovered) {
      const timer = setInterval(() => {
        setCurrentSlide((prev) => (prev + 1) % carouselItems.length);
      }, 6000);
      return () => clearInterval(timer);
    }
  }, [isHovered, carouselItems.length]);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % carouselItems.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + carouselItems.length) % carouselItems.length);
  };

  return (
    <div>
      {/* Interactive Hero Carousel */}
      <section
        className="relative w-full overflow-hidden rounded-b-2xl shadow-2xl"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <div
          className="flex transition-transform duration-700 ease-in-out"
          style={{ transform: `translateX(-${currentSlide * 100}%)` }}
        >
          {carouselItems.map((item, index) => (
            <div key={index} className="w-full flex-shrink-0">
              <div className="relative h-96 md:h-[500px] bg-gradient-to-br from-accent-600 to-accent-800">
                <div className="absolute inset-0 bg-black bg-opacity-50"></div>
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="text-center text-white max-w-4xl px-4">
                    <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold mb-2 text-shadow">
                      {item.title}
                    </h1>
                    <h2 className="text-xl md:text-2xl lg:text-3xl font-semibold mb-4 text-accent-200">
                      {item.subtitle}
                    </h2>
                    <p className="text-lg md:text-xl mb-8 text-secondary-100 leading-relaxed">
                      {item.description}
                    </p>
                    <a
                      href="#registration"
                      className="btn-primary bg-white text-accent-600 hover:bg-secondary-50 text-lg py-3 px-8 inline-block transform hover:scale-105 transition-all duration-300"
                    >
                      {item.cta}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Navigation Arrows */}
        <button
          onClick={prevSlide}
          className="absolute left-4 top-1/2 transform -translate-y-1/2 w-12 h-12 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center text-white hover:bg-white/30 transition-all duration-300 z-10"
          aria-label="Previous slide"
        >
          <i className="bi bi-chevron-left text-xl"></i>
        </button>
        <button
          onClick={nextSlide}
          className="absolute right-4 top-1/2 transform -translate-y-1/2 w-12 h-12 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center text-white hover:bg-white/30 transition-all duration-300 z-10"
          aria-label="Next slide"
        >
          <i className="bi bi-chevron-right text-xl"></i>
        </button>

        {/* Slide Indicators */}
        <div className="absolute bottom-6 left-1/2 transform -translate-x-1/2 flex space-x-2 z-10">
          {carouselItems.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentSlide(index)}
              className={`w-3 h-3 rounded-full transition-all duration-300 ${
                index === currentSlide
                  ? 'bg-white scale-125'
                  : 'bg-white/50 hover:bg-white/75'
              }`}
              aria-label={`Go to slide ${index + 1}`}
            />
          ))}
        </div>
      </section>

      {/* Contact Information Cards */}
      <section className="bg-white section-padding">
        <div className="container-max">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
            <div className="text-center bg-gradient-to-br from-primary-50 to-primary-100 p-8 rounded-2xl">
              <div className="w-16 h-16 bg-primary-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-secondary-900 mb-2">Call Us</h3>
              <p className="text-secondary-600 mb-4">Speak directly with our campaign strategists</p>
              <a href="tel:+254722655911" className="text-primary-600 font-semibold hover:text-primary-700">
                +254 722 655911
              </a>
            </div>

            <div className="text-center bg-gradient-to-br from-secondary-50 to-accent-50 p-8 rounded-2xl">
              <div className="w-16 h-16 bg-accent-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-secondary-900 mb-2">Email Us</h3>
              <p className="text-secondary-600 mb-4">Get detailed campaign proposals and insights</p>
              <a href="mailto:kehosainstitute@gmail.com" className="text-primary-600 font-semibold hover:text-primary-700">
                kehosainstitute@gmail.com
              </a>
            </div>

            <div className="text-center bg-gradient-to-br from-green-50 to-primary-50 p-8 rounded-2xl">
              <div className="w-16 h-16 bg-green-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-secondary-900 mb-2">Visit Us</h3>
              <p className="text-secondary-600 mb-4">Meet our team in person at our offices</p>
              <span className="text-primary-600 font-semibold">3 Locations Nationwide</span>
            </div>
          </div>
        </div>
      </section>

      {/* Consultation Booking Section */}
      <section id="consultation" className="bg-secondary-50 section-padding">
        <div className="container-max">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-secondary-900 mb-4">
              Book Your Consultation
            </h2>
            <p className="text-xl text-secondary-600 max-w-3xl mx-auto">
              Choose the consultation package that best fits your campaign needs and schedule
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
            {consultationTypes.map((consultation, index) => (
              <div
                key={index}
                className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2"
              >
                <div className="text-center mb-6">
                  <h3 className="text-2xl font-bold text-secondary-900 mb-2">{consultation.type}</h3>
                  <div className="text-3xl font-bold text-primary-600 mb-1">{consultation.price}</div>
                  <div className="text-secondary-500">{consultation.duration}</div>
                </div>

                <p className="text-secondary-600 mb-6 text-center leading-relaxed">{consultation.description}</p>

                <ul className="space-y-2 mb-8">
                  <li className="flex items-center">
                    <span className="text-primary-600 mr-2">✓</span>
                    <span className="text-secondary-700 text-sm">Personal consultation with senior strategist</span>
                  </li>
                  <li className="flex items-center">
                    <span className="text-primary-600 mr-2">✓</span>
                    <span className="text-secondary-700 text-sm">Custom campaign assessment report</span>
                  </li>
                  <li className="flex items-center">
                    <span className="text-primary-600 mr-2">✓</span>
                    <span className="text-secondary-700 text-sm">Strategic recommendations</span>
                  </li>
                  <li className="flex items-center">
                    <span className="text-primary-600 mr-2">✓</span>
                    <span className="text-secondary-700 text-sm">Follow-up support</span>
                  </li>
                </ul>

                <button
                  onClick={openConsultationModal}
                  className="btn-primary w-full"
                >
                  Book Now
                </button>
              </div>
            ))}
          </div>

          <div className="text-center">
            <p className="text-secondary-600 mb-4">
              Need a custom consultation package? Contact us for personalized options.
            </p>
            <button className="btn-secondary">
              Request Custom Consultation
            </button>
          </div>
        </div>
      </section>

      {/* Contact Form Section */}
      <section id="contact-form" className="bg-white section-padding">
        <div className="container-max">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-16">
              <h2 className="text-4xl md:text-5xl font-bold text-secondary-900 mb-4">
                Send Us a Message
              </h2>
              <p className="text-xl text-secondary-600 max-w-3xl mx-auto">
                Tell us about your campaign goals and we'll provide tailored strategic guidance
              </p>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
              <div>
                <form onSubmit={handleSubmit} className="space-y-6">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                      <label className="block text-secondary-700 font-semibold mb-2">Full Name *</label>
                      <input
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleInputChange}
                        required
                        className="w-full px-4 py-3 border border-secondary-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent"
                        placeholder="Your full name"
                      />
                    </div>
                    <div>
                      <label className="block text-secondary-700 font-semibold mb-2">Email Address *</label>
                      <input
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleInputChange}
                        required
                        className="w-full px-4 py-3 border border-secondary-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent"
                        placeholder="your@email.com"
                      />
                    </div>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                      <label className="block text-secondary-700 font-semibold mb-2">Phone Number</label>
                      <input
                        type="tel"
                        name="phone"
                        value={formData.phone}
                        onChange={handleInputChange}
                        className="w-full px-4 py-3 border border-secondary-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent"
                        placeholder="+254 XXX XXX XXX"
                      />
                    </div>
                    <div>
                      <label className="block text-secondary-700 font-semibold mb-2">Current Position</label>
                      <select
                        name="position"
                        value={formData.position}
                        onChange={handleInputChange}
                        className="w-full px-4 py-3 border border-secondary-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent"
                      >
                        <option value="">Select position</option>
                        <option value="candidate">Political Candidate</option>
                        <option value="party-official">Party Official</option>
                        <option value="campaign-manager">Campaign Manager</option>
                        <option value="consultant">Political Consultant</option>
                        <option value="other">Other</option>
                      </select>
                    </div>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                      <label className="block text-secondary-700 font-semibold mb-2">County</label>
                      <select
                        name="county"
                        value={formData.county}
                        onChange={handleInputChange}
                        className="w-full px-4 py-3 border border-secondary-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent"
                      >
                        <option value="">Select county</option>
                        <option value="nairobi">Nairobi</option>
                        <option value="kisumu">Kisumu</option>
                        <option value="mombasa">Mombasa</option>
                        <option value="nakuru">Nakuru</option>
                        <option value="other">Other</option>
                      </select>
                    </div>
                    <div>
                      <label className="block text-secondary-700 font-semibold mb-2">Campaign Type</label>
                      <select
                        name="campaignType"
                        value={formData.campaignType}
                        onChange={handleInputChange}
                        className="w-full px-4 py-3 border border-secondary-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent"
                      >
                        <option value="">Select campaign type</option>
                        <option value="presidential">Presidential</option>
                        <option value="gubernatorial">Gubernatorial</option>
                        <option value="parliamentary">Parliamentary</option>
                        <option value="county">County Assembly</option>
                        <option value="ward">Ward/Council</option>
                      </select>
                    </div>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                      <label className="block text-secondary-700 font-semibold mb-2">Budget Range</label>
                      <select
                        name="budget"
                        value={formData.budget}
                        onChange={handleInputChange}
                        className="w-full px-4 py-3 border border-secondary-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent"
                      >
                        <option value="">Select budget range</option>
                        <option value="under-500k">Under KES 500,000</option>
                        <option value="500k-2m">KES 500,000 - 2M</option>
                        <option value="2m-5m">KES 2M - 5M</option>
                        <option value="5m-10m">KES 5M - 10M</option>
                        <option value="over-10m">Over KES 10M</option>
                      </select>
                    </div>
                    <div>
                      <label className="block text-secondary-700 font-semibold mb-2">Timeline</label>
                      <select
                        name="timeline"
                        value={formData.timeline}
                        onChange={handleInputChange}
                        className="w-full px-4 py-3 border border-secondary-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent"
                      >
                        <option value="">Select timeline</option>
                        <option value="immediate">Immediate (within 1 month)</option>
                        <option value="3-months">Within 3 months</option>
                        <option value="6-months">Within 6 months</option>
                        <option value="1-year">Within 1 year</option>
                        <option value="exploring">Just exploring options</option>
                      </select>
                    </div>
                  </div>

                  <div>
                    <label className="block text-secondary-700 font-semibold mb-2">Message *</label>
                    <textarea
                      name="message"
                      value={formData.message}
                      onChange={handleInputChange}
                      required
                      rows={6}
                      className="w-full px-4 py-3 border border-secondary-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent"
                      placeholder="Tell us about your campaign goals, challenges, and what you're looking to achieve..."
                    ></textarea>
                  </div>

                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className={`btn-primary w-full ${isSubmitting ? 'opacity-50 cursor-not-allowed' : ''}`}
                  >
                    {isSubmitting ? 'Sending...' : 'Send Message'}
                  </button>
                </form>
              </div>

              <div className="space-y-8">
                <div className="bg-gradient-to-br from-primary-50 to-secondary-50 p-8 rounded-2xl">
                  <h3 className="text-2xl font-bold text-secondary-900 mb-6">Why Contact Us?</h3>
                  <div className="space-y-4">
                    <div className="flex items-start space-x-4">
                      <div className="w-8 h-8 bg-primary-600 rounded-full flex items-center justify-center flex-shrink-0">
                        <span className="text-white font-bold">✓</span>
                      </div>
                      <div>
                        <h4 className="font-semibold text-secondary-900">Expert Consultation</h4>
                        <p className="text-secondary-600 text-sm">Speak with certified political strategists</p>
                      </div>
                    </div>
                    <div className="flex items-start space-x-4">
                      <div className="w-8 h-8 bg-primary-600 rounded-full flex items-center justify-center flex-shrink-0">
                        <span className="text-white font-bold">✓</span>
                      </div>
                      <div>
                        <h4 className="font-semibold text-secondary-900">Custom Strategy</h4>
                        <p className="text-secondary-600 text-sm">Tailored solutions for your unique campaign</p>
                      </div>
                    </div>
                    <div className="flex items-start space-x-4">
                      <div className="w-8 h-8 bg-primary-600 rounded-full flex items-center justify-center flex-shrink-0">
                        <span className="text-white font-bold">✓</span>
                      </div>
                      <div>
                        <h4 className="font-semibold text-secondary-900">Confidential</h4>
                        <p className="text-secondary-600 text-sm">Complete discretion and professional handling</p>
                      </div>
                    </div>
                    <div className="flex items-start space-x-4">
                      <div className="w-8 h-8 bg-primary-600 rounded-full flex items-center justify-center flex-shrink-0">
                        <span className="text-white font-bold">✓</span>
                      </div>
                      <div>
                        <h4 className="font-semibold text-secondary-900">No Obligation</h4>
                        <p className="text-secondary-600 text-sm">Free initial consultation with no commitment</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="bg-secondary-900 text-white p-8 rounded-2xl">
                  <h3 className="text-2xl font-bold mb-6">Response Time</h3>
                  <div className="space-y-4">
                    <div className="flex justify-between items-center">
                      <span>Email Inquiries</span>
                      <span className="bg-primary-600 px-3 py-1 rounded-full text-sm">Within 24 hours</span>
                    </div>
                    <div className="flex justify-between items-center">
                      <span>Phone Calls</span>
                      <span className="bg-primary-600 px-3 py-1 rounded-full text-sm">Immediate</span>
                    </div>
                    <div className="flex justify-between items-center">
                      <span>Consultation Booking</span>
                      <span className="bg-primary-600 px-3 py-1 rounded-full text-sm">Within 48 hours</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Office Locations */}
      <section className="bg-secondary-50 section-padding">
        <div className="container-max">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-secondary-900 mb-4">
              Our Offices
            </h2>
            <p className="text-xl text-secondary-600 max-w-3xl mx-auto">
              Visit us at our offices across Kenya for in-person consultations and strategy sessions
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {officeLocations.map((office, index) => (
              <div
                key={index}
                className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300"
              >
                <div className="text-center mb-6">
                  <h3 className="text-2xl font-bold text-secondary-900 mb-2">{office.city}</h3>
                  {/* Location Image */}
                  <div className="w-full h-24 mb-4 rounded-lg overflow-hidden">
                    <img
                      src={
                        office.city.includes("Kehosa Institute")
                          ? "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=300&h=200&fit=crop"
                          : office.city.includes("Democracy Institute")
                          ? "https://images.unsplash.com/photo-1589391886645-d51941baf7fb?w=300&h=200&fit=crop"
                          : "https://images.unsplash.com/photo-1497366216548-37526070297c?w=300&h=200&fit=crop"
                      }
                      alt={`${office.city} office`}
                      className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                    />
                  </div>
                </div>

                <div className="space-y-3 text-center">
                  <p className="text-secondary-600">{office.address}</p>
                  <p className="text-secondary-600">
                    <span className="font-semibold">Phone:</span> {office.phone}
                  </p>
                  <p className="text-secondary-600">
                    <span className="font-semibold">Email:</span> {office.email}
                  </p>
                  <p className="text-secondary-600">
                    <span className="font-semibold">Hours:</span> {office.hours}
                  </p>
                </div>

                <div className="mt-6 text-center">
                  <button className="btn-primary">
                    Schedule Visit
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="bg-gradient-to-r from-primary-600 to-primary-800 text-white section-padding">
        <div className="container-max text-center">
          <h2 className="text-4xl md:text-6xl font-bold mb-6">
            Ready to Start Winning?
          </h2>
          <p className="text-xl mb-8 max-w-3xl mx-auto text-primary-100">
            Don't wait for election day to start planning. Contact us today and secure
            your path to electoral success with Kenya's leading political strategists.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a href="#consultation" className="btn-primary bg-white text-primary-600 hover:bg-secondary-50 transform hover:scale-105 transition-transform duration-200">
              Book Consultation Now
            </a>
            <a href="#contact-form" className="btn-secondary bg-transparent border-white text-white hover:bg-white hover:text-primary-600 transform hover:scale-105 transition-transform duration-200">
              Send Quick Message
            </a>
          </div>
        </div>
      </section>

      {/* Consultation Modal */}
      <ConsultationModal
        isOpen={isConsultationModalOpen}
        onClose={closeConsultationModal}
      />
    </div>
  );
};

export default Contact;